var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.isAuthenticated)?[_c('Layout',[_c('router-view')],1)]:_c('router-view'),_c('Snack')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }